export default __webpack_public_path__ + "static/media/05_Business-PortraitArchitecture-InteriorEschweilerPhotography_M1A6854.4f0aca2f.jpg";